import { Package, Wrench } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PartsCatalog } from './PartsCatalog';
import { ServiceCatalog } from './ServiceCatalog';

/** Settings -> Line Items: the priced things that go on quotes and invoices. */
export function LineItems({ defaultSection = 'parts' }: { defaultSection?: 'parts' | 'services' }) {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold">Line Items</h2>
        <p className="text-sm text-muted-foreground">
          The parts and services you put on quotes and invoices. Prices here are defaults; every line stays editable.
        </p>
      </div>
      <Tabs defaultValue={defaultSection}>
        <TabsList>
          <TabsTrigger value="parts" className="gap-2">
            <Package className="h-4 w-4" />
            Parts
          </TabsTrigger>
          <TabsTrigger value="services" className="gap-2">
            <Wrench className="h-4 w-4" />
            Services
          </TabsTrigger>
        </TabsList>
        <TabsContent value="parts" className="mt-4">
          <PartsCatalog />
        </TabsContent>
        <TabsContent value="services" className="mt-4">
          <ServiceCatalog />
        </TabsContent>
      </Tabs>
    </div>
  );
}
